export const iconFontAwesomeCampingKitMedical = (
	<i className="fa-solid fa-kit-medical"></i>
);
